import { UpHorizontalIcon } from '../../assets/Icons';

function UrbanPiperFooter() {
  return (
    <div className="flex justify-center items-center gap-x-2 text-xs font-normal text-up-black-20 mb-4">
      <p>Powered by</p>
      <UpHorizontalIcon />
    </div>
  );
}

export default UrbanPiperFooter;
